/** Formulaire fiche client (sections empilées). */
import { useState } from "react";
import { Button } from "../../components/Button";
import { clientProfileGaps } from "../../legal/clientKind";
import { AddressSection } from "./AddressSection";
import { CompanySection } from "./CompanySection";
import { ContactsSection } from "./ContactsSection";
import type { ClientDraft } from "./types";

type ClientFormProps = {
  draft: ClientDraft;
  setDraft: (next: ClientDraft) => void;
  busy: boolean;
  setBusy: (v: boolean) => void;
  error: string;
  setError: (msg: string) => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete?: () => void;
};

export function ClientForm({
  draft,
  setDraft,
  busy,
  setBusy,
  error,
  setError,
  onSave,
  onCancel,
  onDelete,
}: ClientFormProps) {
  const [tried, setTried] = useState(false);
  const gaps = clientProfileGaps(draft);

  return (
    <form
      noValidate
      className="mb-4 flex w-full flex-col gap-6 rounded-2xl bg-white p-5 ring-1 ring-indigo-100"
      onSubmit={(e) => {
        e.preventDefault();
        if (gaps.length) {
          setTried(true);
          requestAnimationFrame(() => {
            document.querySelector(".fx-field.is-miss, .fx-siret.is-miss")?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          });
          return;
        }
        onSave();
      }}
    >
      {error ? <p className="m-0 rounded-lg bg-red-100 px-3 py-2 text-sm text-red-800">{error}</p> : null}
      <div className="grid w-full gap-6 lg:grid-cols-2 lg:items-start">
        <CompanySection
          draft={draft}
          setDraft={setDraft}
          onError={setError}
          busy={busy}
          setBusy={setBusy}
          tried={tried}
        />
        <div className="grid gap-6">
          <ContactsSection draft={draft} setDraft={setDraft} />
          <AddressSection draft={draft} setDraft={setDraft} tried={tried} />
        </div>
      </div>
      <div className="flex flex-wrap justify-end gap-2">
        {onDelete ? (
          <Button variant="danger" onClick={onDelete} disabled={busy}>
            Supprimer
          </Button>
        ) : null}
        <Button variant="ghost" onClick={onCancel}>
          Annuler
        </Button>
        <Button type="submit" disabled={busy}>
          Enregistrer
        </Button>
      </div>
    </form>
  );
}
